import Spinner from './Spinner'

interface LoadingScreenProps {
  message?: string
}

const LoadingScreen = ({ message }: LoadingScreenProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Spinner size="lg" />
      {message && <p className="mt-4 text-gray-600">{message}</p>}
    </div>
  )
}

export default LoadingScreen
